import { gql } from '@apollo/client'

export const COUNT_MIGRANTS_NOTIFICATIONS = gql`
  query Query {
    count: getMigrantsCountNotificationsByUser
  }
`

export const MIGRANTS_NOTIFICATION_ADDED = gql`
  subscription MigrantsNotificationAdd {
    migrantsNotificationAdd {
      id
      id_user
      type_user
      message
      link
      notification_type
      id_ref
      viewed
      viewed_date
      createdAt
      updatedAt
    }
  }
`

export const USER_MIGRANTS_NOTIFICATIONS = gql`
  query GetAllMigrantsNotificationsByUser($limit: Int, $offset: Int) {
    all: getAllMigrantsNotificationsByUser(limit: $limit, offset: $offset) {
      id
      message
      link
      createdAt
      dayDif
      timeDiff
      notification_type
    }
  }
`

export const MARK_ALL_MIGRANTS_NOTIFICATIONS_AS_READ = gql`
  mutation MarkAllMigrantsNotificationsAsRead($query: String) {
    markAllMigrantsNotificationsAsRead(query: $query)
  }
`

export const UPDATE_VIEWED_MIGRANTS_NOTIFICATION = gql`
  mutation UpdateViewedMigrantsNotificationsById($id: Int!) {
    updateViewedMigrantsNotificationsById(id: $id)
  }
`